// extracted by mini-css-extract-plugin
export var leftAlign = "_3b-2";
export var popper = "_3b-0";
export var subtitle = "_3b-1";